module.exports = __webpack_public_path__ + "img/coins-and-receipt.8592f686.jpg";